import React, { useState } from "react";
import MobileHeader from "./MobileHeader";
import MobileBottomNav from "./MobileBottomNav";
import MobileDrawer from "./MobileDrawer";
import "./MobileLayout.css";

const MobileLayout = ({ children, currentUser }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <div className="mobile-layout">
      <MobileHeader
        currentUser={currentUser}
        onOpenMenu={() => setDrawerOpen(true)}
      />

      <main className="mobile-layout-content">{children}</main>

      <MobileBottomNav currentUser={currentUser} />

      <MobileDrawer
        currentUser={currentUser}
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      />
    </div>
  );
};

export default MobileLayout;
